import React, { useState, useEffect, useContext, useCallback } from "react";
import { Tab } from "@mui/material";
import { TabList, TabPanel, TabContext } from "@mui/lab";
import FieldText from "../../../../common/component/form/FieldText";
import FieldDate from "../../../../common/component/form/FieldDate";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from "@mui/material";
import Slider from "../../../../common/component/slider/Slider";
import LayoutCreateOrder from "../../../../common/layout/LayoutCreateOrder";
import OrderMap from "../orderCreation/OrderMap";
import useForm from "../../../../common/hooks/useForm";
import { path } from "../../../../constants/apiPath";
import { useNavigate, useLocation } from "react-router-dom";
import { StoreContext } from "../../../../store";
import moment from "moment";
import instance from "../../../../common/api/interceptor";
import Schedule from "./schedule/Schedule";
import axios from "axios";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import ScheduleTable from "./schedule/ScheduleTable";
import { NotificationManager } from "react-notifications";
import ModalOrderPlan from "../../../../constants/data/ModalOrderPlan";
import ModalContainer from "../../../../constants/data/ModalContainer";
import CancelPresentationRoundedIcon from "@mui/icons-material/CancelPresentationRounded";
import DoDisturbOnOutlinedIcon from "@mui/icons-material/DoDisturbOnOutlined";
import debounce from "lodash.debounce";
import Loading from "../../../loading/Loading";
import routeConstant from "../../../../../route/compoent/routeConstant";
import RatesModal from "../../../../constants/data/RatesModal";

function OrderPlan() {
  const [edit, setEdit] = useState(false);

  const context = useContext(StoreContext);

  const [directions, setDirections] = useState("D");
  const [valueSlider, setValueSlider] = useState(2);

  const [showSchedule, setShowSchedule] = useState(false);
  const [scheduleSelected, setScheduleSelected] = useState(false);
  const [scheduleSelectedData, setScheduleSelectedData] = useState([]);
  const [originPortInput, setOriginPortInput] = useState("");
  const [destinationPortInput, setDestinationPortInput] = useState("");
  const navigate = useNavigate();

  //plan
  const [loading, setLoading] = useState(false);
  const [searchResult, setSearchResult] = useState([]);
  const [comLogo, setComLogo] = useState([]);
  const [compName, setCompName] = useState([]);
  const [lines, setLines] = useState([]);

  const [carrierOptions, setCarrierOptions] = useState([]);
  const [freezePlanData, setFreezePlanData] = useState([]);
  const [isFreeze, setIsFreeze] = useState(false);
  const [inputDisabled, setInputDisabled] = useState(false);

  const [orderPlanJson, setOrderPlanJson] = useState([]);
  const forwarderOptions = [
    { value: "MTS", key: "0" },
    { key: "1", value: "Other" },
  ];

  const location = useLocation();

  useEffect(() => {
    if (!location.state) {
      if (location.pathname.includes(routeConstant.ORDER_LIST)) {
        navigate(routeConstant.ORDER_LIST_PLACED, { replace: true });
      } else if (location.pathname.includes(routeConstant.ORDER_DASHBOARD)) {
        navigate(routeConstant.ORDER_DASHBOARD, { replace: true });
      }
    } else {
      context.setValue("1");
      getAgentOrCarrier("Carrier");
      const disabled =
        location.state.editOrderJSON.OrderHeader.OrderType === "SUB"
          ? true
          : !context.orderUserAccess?.EditOrderPlan;
      setInputDisabled(disabled);
      const orderPlan =
        JSON.parse(
          JSON.stringify(location.state.editOrderJSON.OrderPlanningCollection)
        ) ?? [];
      orderPlan.map((ele, index, arr) => {
        if (ele.IsFreezed) {
          setIsFreeze(true);
          context.setValue((index + 1).toString());
        }
        if (typeof ele.PlanningOriginCountryName === "string") {
          arr[index].PlanningOriginCountryName = {
            Code: ele.PlanningOriginCountryCode ?? "",
            Description: ele.PlanningOriginCountryName ?? "",
          };
        }
        ele.PlanningOrderReadyDate =
          location.state.editOrderJSON?.OrderHeader?.OrderExWorksRequiredBy;
        if (typeof ele.PlanningOriginPortName === "string") {
          arr[index].PlanningOriginPortName = {
            Code: ele.PlanningOriginPortCode ?? "",
            PortName: ele.PlanningOriginPortName ?? "",
            Lat: ele.PlanningDestinationLat,
            Lng: ele.PlanningDestinationLng,
          };
        }

        if (typeof ele.PlanningDestinationCountryName === "string") {
          arr[index].PlanningDestinationCountryName = {
            Code: ele.PlanningDestinationCountryCode ?? "",
            Description: ele.PlanningDestinationCountryName ?? "",
          };
        }

        if (typeof ele.PlanningDestinationPortName === "string") {
          arr[index].PlanningDestinationPortName = {
            Code: ele.PlanningDestinationPortCode ?? "",
            PortName: ele.PlanningDestinationPortName ?? "",
            Lat: ele.PlanningOriginLat ?? "",
            Lng: ele.PlanningOriginLng,
          };
        }

        if (typeof ele.PlanningReceivingAgentCode === "string") {
          arr[index].PlanningReceivingAgentCode = {
            OrgPk: ele.PlanningReceivingAgentPK ?? "",
            OrgCode: ele.PlanningReceivingAgentCode ?? "",
          };
        }

        if (typeof ele.PlanningSendingAgentCode === "string") {
          arr[index].PlanningSendingAgentCode = {
            OrgPk: ele.PlanningSendingAgentPK ?? "",
            OrgCode: ele.PlanningSendingAgentCode ?? "",
          };
        }

        if (typeof ele.PlanningCarrierCode === "string") {
          arr[index].PlanningCarrierCode = {
            OrgPk: ele.PlanningCarrierPK ?? "",
            OrgCode: ele.PlanningCarrierCode ?? "",
          };
        }

        if (typeof ele.PlanningFinalDestination === "string") {
          arr[index].PlanningFinalDestination = {
            PortName: ele.PlanningFinalDestinationPortName,
            Code: ele.PlanningFinalDestination ?? "",
          };
        }

        if (typeof ele.PlanningForwarderCarrier === "string") {
          arr[index].PlanningForwarderCarrier = {
            value: ele.PlanningForwarderCarrier ?? "",
          };
        }
        if (ele.OrderPlanningContainerCollection) {
          ele.OrderPlanningContainerCollection.map((item, i) => {
            if (
              typeof arr[index].OrderPlanningContainerCollection[i]
                .ContainerWeightUnit === "string"
            ) {
              arr[index].OrderPlanningContainerCollection[
                i
              ].ContainerWeightUnit = {
                ...getOptions(
                  context.defaultValue.weightType,
                  "Unit",
                  item.ContainerWeightUnit,
                  "Description"
                ),
              };
            }

            if (
              typeof arr[index].OrderPlanningContainerCollection[i]
                .ContainerType === "string"
            ) {
              arr[index].OrderPlanningContainerCollection[i].ContainerType = {
                Code: item.ContainerType,
              };
            }
          });
        }

        if (ele.OrderPlanningContainerRatesCollection) {
          ele.OrderPlanningContainerRatesCollection.map((item, i) => {
            if (
              typeof arr[index].OrderPlanningContainerRatesCollection[i]
                .ContainerRType === "string"
            ) {
              arr[index].OrderPlanningContainerRatesCollection[
                i
              ].ContainerRType = {
                Code: item.ContainerRType,
              };
            }
          });
        }
      });

      setOrderPlanJson([...orderPlan]);
    }
  }, [location.state]);

  const onContainerRatesAdd = (index) => {
    const orderPlan = [...orderPlanJson];
    const rate = { ...RatesModal };

    rate.ContainerRateOrderFK = orderPlan[context.value - 1].PlanningFk;
    rate.ContainerRateplanningFK = orderPlan[context.value - 1].PlanningPk;
    orderPlan[index].OrderPlanningContainerRatesCollection = orderPlan[index]
      .OrderPlanningContainerRatesCollection
      ? [...orderPlan[index].OrderPlanningContainerRatesCollection]
      : [];
    orderPlan[index].OrderPlanningContainerRatesCollection.push({
      ...rate,
    });
    setOrderPlanJson([...orderPlan]);
  };

  const onContainerRatesRemove = (index, itemIndex, element) => {
    if (element.ContainerRatePk) {
      const url = `${path.DELETE_RATE_PER_CONTAINER}?orderPK=${element.ContainerRateOrderFK}&planningPK=${element.ContainerRateplanningFK}&containerRatePK=${element.ContainerRatePk}`;

      instance
        .delete(url)
        .then((res) => {
          if (res.Is_Success) {
            const orderPlan = [...orderPlanJson];

            orderPlan[index].OrderPlanningContainerRatesCollection.splice(
              itemIndex,
              1
            );
            setOrderPlanJson([...orderPlan]);

            NotificationManager.success("Removed Successfully!!");
          } else {
            NotificationManager.error(res.Message);
          }
          console.log("res", res);
        })
        .catch((err) => {
          NotificationManager.error("Data Does Not Exists In Database");

          console.log("err", err);
        });
    } else {
      const orderPlan = [...orderPlanJson];

      orderPlan[index].OrderPlanningContainerRatesCollection.splice(
        itemIndex,
        1
      );

      setOrderPlanJson([...orderPlan]);
    }
  };

  const onContainerRateChange = (value, key, index, itemIndex) => {
    const arr = [...orderPlanJson];
    arr[index].OrderPlanningContainerRatesCollection[itemIndex][key] = value;
    setOrderPlanJson([...arr]);
  };

  const getOptions = (data = [], key, value, item = "Description") => {
    if (typeof value === "string") {
      const arr = [...data] ?? [];
      const result = arr.filter((word) => word[key] === value);
      // console.log("result", result, { [key]: "" });

      return result.length ? result.pop() : { [item]: "" };
    } else {
      return value;
    }
  };

  const getAgentOrCarrier = (type) => {
    instance
      .get(`${path.AGENT_CARRIER}${type}&orgPk=`)
      .then((res) => {
        console.log(type, res.data);
        setCarrierOptions(res.data ?? []);
      })
      .catch(() => {
        return [];
      });
  };

  const onNextHandler = (path) => {
    const body = {
      ...location.state.editOrderJSON,
      OrderPlanningCollection: [...orderPlanJson],
      OrderNotesCollection: [],
    };
    context.setEditOrderJSON({
      ...body,
    });
    navigate(path, {
      state: { edit: edit, editOrderJSON: body },
    });

    console.log("orderPlanJson", body);
  };

  const getScheduleCards = async (data) => {
    context.setBackDropOpen(true);
    const URL = `https://dashboard.mts-logistics.com/MTSConnectAPIServices/api/GetSearchResults?origin_code=${
      data?.PlanningOriginPortName?.Code ?? ""
    }&destination_code=${
      data?.PlanningDestinationPortName?.Code ?? ""
    }&start_date=${
      data.PlanningCutOfDate
        ? moment(data.PlanningCutOfDate).format("DD-MM-YYYY")
        : moment().format("DD-MM-YYYY")
    }&weeks_ahead=${valueSlider}&direction_A_or_D=${directions}&sac_codes=${
      data.PlanningCarrierCode?.ShippingSacCode ?? ""
    }`;

    await axios
      .post(URL)
      .then((res) => {
        context.setBackDropOpen(false);
        if (res?.data?.shipping_lines?.length) {
          let logo = [];
          let data = [];
          let companyName = [];
          res.data.shipping_lines.forEach((element) => {
            logo.push(element.line_logo);
            companyName.push(element.line_name);
            let tempData = [];
            element.line.forEach((item) => {
              tempData.push(item);
            });
            data.push(tempData);
          });
          setComLogo(logo);
          setCompName(companyName);
          setLines(data);
          setSearchResult(res.data.shipping_lines);
        }
        setShowSchedule(true);
      })
      .catch((err) => {
        context.setBackDropOpen(false);
        NotificationManager.error("Something went wrong", "", 3000);
        console.error(err);
      });
  };

  const onRequestQuote = (item, comLogo, compName, cutoffdate, data) => {
    console.log(data);
    console.log(context.value);

    let depart = new Date(0);
    depart.setUTCSeconds(data.originDate);
    let arrival = new Date(0);
    arrival.setUTCSeconds(data.destinationDate);

    let cut = new Date(0);
    cut.setUTCSeconds(data.cutoffDate);

    const orderPlan = [...orderPlanJson];

    orderPlan[parseInt(context.value - 1)].PlanningVessel = data.vesselName;
    orderPlan[parseInt(context.value - 1)].PlanningVoyage = data.voyage;
    orderPlan[parseInt(context.value - 1)].PlanningCarrierCode = data.carrier;
    orderPlan[parseInt(context.value - 1)].PlanningEstimatedDepart = depart;
    orderPlan[parseInt(context.value - 1)].PlanningEstimatedArrival = arrival;
    orderPlan[parseInt(context.value - 1)].PlanningCutOfDate = cut;

    setShowSchedule(false);

    console.log({ orderPlan });
  };

  const onAddHandler = () => {
    const arr = [...orderPlanJson];
    arr.push({ ...ModalOrderPlan });
    context.setValue(arr.length.toString());
    setOrderPlanJson(arr);
  };

  const onChangeHandler = (lable, value, index) => {
    const arr = [...orderPlanJson];
    arr[index][lable] = value;
    setOrderPlanJson([...arr]);
  };

  const onAddContainer = (index) => {
    const orderPlan = [...orderPlanJson];
    orderPlan[index].OrderPlanningContainerCollection.push({
      ...ModalContainer,
    });
    setOrderPlanJson([...orderPlan]);
  };

  const onContainerHandler = (lable, value, arrIndex, index) => {
    console.log(orderPlanJson);
    const orderPlan = JSON.parse(JSON.stringify(orderPlanJson));

    orderPlan[arrIndex].OrderPlanningContainerCollection.map((item, i, arr) => {
      if (i === index) {
        arr[index][lable] = value;
      }
      arr[index].ContainerplanningFK = orderPlan[arrIndex].PlanningPk;
      arr[index].ContainerOrderFK =
        location.state.editOrderJSON?.OrderHeader?.OrderPK;
    });

    setOrderPlanJson([...orderPlan]);
  };

  const onOrderFreeze = () => {
    context.setBackDropOpen(true);
    const body = [];
    const orderplan = [...orderPlanJson];
    orderplan.map((ele, index, arr) => {
      const obj = {
        OrderPk: location.state.editOrderJSON.OrderHeader.OrderPK,
        OrderPlanningPk: ele.PlanningPk,
        OrderPlanningIsFreezed:
          index + 1 == parseInt(context.value) ? true : false,
      };
      // arr[index].IsFreezed =
      //   index + 1 == parseInt(context.value) ? true : false;
      body.push(obj);
    });
    console.log("ORDER_FREEZE", orderplan);
    instance
      .post(`${path.ORDER_FREEZE}`, body)
      .then((res) => {
        if (res.Is_Success) {
          NotificationManager.success(res.Message, "", 3000);
          setFreezePlanData(body);
          // setAtleastOneFreezed(true);
          setIsFreeze(true);

          orderplan.map((ele, index, arr) => {
            arr[index].IsFreezed =
              index + 1 == parseInt(context.value) ? true : false;
          });

          setOrderPlanJson([...orderplan]);
        } else {
          NotificationManager.error(res.Message, "", 3000);
        }
        context.setBackDropOpen(false);
      })
      .catch((err) => {
        console.error(err);
        if (err.response) {
          NotificationManager.error(err.response.data.Message, "", 3000);
        } else if (err.request) {
        } else if (err.message) {
        } else {
          NotificationManager.error("Something went wrong!", "", 3000);
        }
        context.setBackDropOpen(false);
      });
  };

  const onOrderUnFreeze = () => {
    context.setBackDropOpen(true);
    const body = [];
    const orderplan = [...orderPlanJson];
    orderplan.map((ele, index, arr) => {
      const obj = {
        OrderPk: location.state.editOrderJSON.OrderHeader.OrderPK,
        OrderPlanningPk: ele.PlanningPk,
        OrderPlanningIsFreezed: false,
      };
      // arr[index].IsFreezed = false;
      body.push(obj);
    });
    instance
      .post(`${path.ORDER_FREEZE}`, body)
      .then((res) => {
        if (res.Is_Success) {
          NotificationManager.success(res.Message, "", 3000);
          setOrderPlanJson([...orderplan]);
          orderplan.map((ele, index, arr) => {
            arr[index].IsFreezed = false;
          });

          setIsFreeze(false);
        } else {
          NotificationManager.error(res.Message, "", 3000);
        }
        context.setBackDropOpen(false);
      })
      .catch((err) => {
        console.error(err);
        if (err.response) {
          NotificationManager.error(err.response.data.Message, "", 3000);
        } else if (err.request) {
        } else if (err.message) {
        } else {
          NotificationManager.error("Something went wrong!", "", 3000);
        }
        context.setBackDropOpen(false);
      });
  };

  const getPorts = useCallback(
    debounce((country, port, type = "origin") => {
      instance
        .get(`${path.GET_UNLOCO}`, {
          params: {
            country: country,
            portcodeorname: port,
          },
        })
        .then(async (res) => {
          if (type === "origin") {
            await context.setOriginPort([]);
            context.setOriginPort(res.data ?? []);
          } else {
            await context.setDestinationPort([]);
            context.setDestinationPort(res.data ?? []);
           
          }
        })
        .catch((err) => {
          console.log("error section", err);
          if (type === "origin") {
            context.setOriginPort([]);
          } else {
            context.setDestinationPort([]);
          }
        });
    }, 200),
    []
  );

  const deletePlan = (event, ele, index) => {
    event.stopPropagation();

    const arr = [...orderPlanJson];

    if (ele.PlanningPk) {
      const url = `${path.DELETE_ORDER_PLAN}?orderPK=${location.state.editOrderJSON.OrderHeader.OrderPK}&planningPK=${ele.PlanningPk}`;
      instance
        .delete(url)
        .then((res) => {
          if (res.Is_Success) {
            arr.splice(index, 1);
            console.log({ arr });
            context.setEditOrderJSON({
              ...location.state.editOrderJSON,
              OrderPlanningCollection: [...arr],
            });
            setOrderPlanJson([...arr]);
            context.setValue((prev) => {
              if (arr.length > 0) {
                if (parseInt(prev) === 1) {
                  return "1";
                }
                if (parseInt(prev) > 1) {
                  return (parseInt(prev) - 1).toString();
                }
              }
            });
            NotificationManager.success(res.Message, "", 3000);
          } else {
            NotificationManager.error(res.Message, "", 3000);
          }
        })
        .catch((err) => {
          console.error(err);
          if (err.response) {
            NotificationManager.error(err.response.data.Message, "", 3000);
          } else if (err.request) {
          } else if (err.message) {
          } else {
            NotificationManager.error("Something went wrong!", "", 3000);
          }
        });
    } else {
      arr.splice(index, 1);
    }
    setOrderPlanJson([...arr]);
  };

  const onContainerRemove = (index, itemIndex, plan, container) => {
    const orderPlan = [...JSON.parse(JSON.stringify(orderPlanJson))];

    if (container.ContainerPk) {
      const url = `${path.DELETE_PLAN_CONTAINER}?orderPK=${location.state.editOrderJSON.OrderHeader.OrderPK}&planningPK=${plan.PlanningPk}&containerPK=${container.ContainerPk}`;
      instance
        .delete(url)
        .then((res) => {
          if (res.Is_Success) {
            orderPlan[index].OrderPlanningContainerCollection.splice(
              itemIndex,
              1
            );

            context.setEditOrderJSON({
              ...location.state.editOrderJSON,
              OrderPlanningCollection: [...orderPlan],
            });
            setOrderPlanJson([...orderPlan]);
            NotificationManager.success(res.Message, "", 3000);
          } else {
            NotificationManager.error(res.Message, "", 3000);
          }
        })
        .catch((err) => {
          console.error(err);
          if (err.response) {
            NotificationManager.error(err.response.data.Message, "", 3000);
          } else if (err.request) {
          } else if (err.message) {
          } else {
            NotificationManager.error("Something went wrong!", "", 3000);
          }
        });
    } else {
      orderPlan[index].OrderPlanningContainerCollection.splice(itemIndex, 1);
      setOrderPlanJson([...orderPlan]);
    }
  };

  if (!location.state) return <Loading />;

  return (
    <LayoutCreateOrder onNextHandler={onNextHandler} title="Create Order">
      <div className="_orderPlanComp">
        <TabContext value={context.value}>
          <TabList
            variant="scrollable"
            scrollButtons="auto"
            onChange={(event, newValue) => context.setValue(newValue)}
            className="_orderPlanTabs"
          >
            {orderPlanJson.map((ele, index) => {
              let num = index + 1;
              return (
                <Tab
                  disabled={
                    isFreeze &&
                    location.state.editOrderJSON.OrderHeader.OrderStatus ===
                      "SHP"
                      ? true
                      : false
                  }
                  label={
                    num < 10 ? (
                      <div className="_orderPlanTabsDiv">
                        Plan 0{num}
                        {index + 1 === parseInt(context.value) ? (
                          <button
                            disabled={
                              ele.PlanningPk &&
                              !context.orderUserAccess?.DeleteOrderPlan
                            }
                            onClick={(e) => {
                              deletePlan(e, ele, index);
                            }}
                          >
                            <CancelPresentationRoundedIcon />
                          </button>
                        ) : null}
                      </div>
                    ) : (
                      <div className="_orderPlanTabsDiv">
                        Plan {num}
                        {index + 1 === parseInt(context.value) ? (
                          <button
                            disabled={
                              ele.PlanningPk &&
                              !context.orderUserAccess?.deletePlan
                            }
                            onClick={(e) => {
                              deletePlan(e, ele, index);
                            }}
                          >
                            <CancelPresentationRoundedIcon />
                          </button>
                        ) : null}
                      </div>
                    )
                  }
                  value={num.toString()}
                  key={num}
                />
              );
            })}
            <div className="_addPlan _editPlan">
              {!showSchedule && (
                <div className="_solidButton">
                  {location.state.editOrderJSON?.OrderHeader?.OrderStatus ===
                  "SHP" ? null : (
                    <button
                      disabled={
                        location.state.editOrderJSON.OrderHeader.OrderType ===
                          "SUB" || !context.orderUserAccess?.CreateOrderPlan
                      }
                      onClick={() => {
                        onAddHandler();
                      }}
                    >
                      + Add Plan
                    </button>
                  )}
                </div>
              )}

              {!showSchedule && (
                <div className="_solidButton">
                  {orderPlanJson.length ? (
                    orderPlanJson[parseInt(context.value) - 1]?.IsFreezed ? (
                      <button
                        disabled={
                          location.state.editOrderJSON.OrderHeader.OrderType ===
                            "SUB" || !context.orderUserAccess?.FreezedPlan
                        }
                        onClick={onOrderUnFreeze}
                      >
                        Unselect Plan
                        {context.value < 10
                          ? ` 0${context.value}`
                          : ` ${context.value}`}
                      </button>
                    ) : (
                      <button
                        disabled={
                          location.state.editOrderJSON.OrderHeader.OrderType ===
                            "SUB" || !context.orderUserAccess?.FreezedPlan
                        }
                        onClick={onOrderFreeze}
                      >
                        Select Plan
                        {context.value < 10
                          ? ` 0${context.value}`
                          : ` ${context.value}`}
                      </button>
                    )
                  ) : (
                    ""
                  )}
                </div>
              )}
            </div>
          </TabList>
          {orderPlanJson.map((ele, index) => {
            let num = index + 1;
            return (
              <TabPanel
                value={num.toString()}
                index={num}
                className={`_orderPlanTabBody _orderPlanTabBody${ele}`}
                key={index}
              >
                <div className="container-fluid">
                  {/* <RequestQuoteCard /> */}
                  {scheduleSelected ? (
                    <ScheduleTable
                      setScheduleSelected={setScheduleSelected}
                      scheduleSelectedData={scheduleSelectedData}
                    />
                  ) : showSchedule ? (
                    <Schedule
                      loading={loading}
                      searchResult={searchResult}
                      comLogo={comLogo}
                      compName={compName}
                      lines={lines}
                      onRequestQuote={onRequestQuote}
                      setShowSchedule={setShowSchedule}
                      setScheduleSelected={setScheduleSelected}
                    />
                  ) : (
                    <div className="row">
                      <div className="col-lg-8 col-12 _orderPlan">
                        <div className="row">
                          <div className="col-md-5 col-12 _orderPlanPlace">
                            <div className="_orderTimelineDivParent">
                              <div className="_orderTimelineDiv">
                                <div className="_orderTimelineDotLine">
                                  <div className="_orderTimelineDot"></div>
                                  <div className="_orderTimelineLine" />
                                </div>
                                <div className="_orderTimelineInputs">
                                  <h6>Origin</h6>
                                  <div className={`width100`}>
                                    <Autocomplete
                                      disabled={ele.IsFreezed || inputDisabled}
                                      disablePortal
                                      disableClearable={false}
                                      size="small"
                                      value={ele.PlanningOriginCountryName}
                                      onChange={(event, newValue) => {
                                        onChangeHandler(
                                          "PlanningOriginCountryName",
                                          newValue ?? { Description: "" },
                                          index
                                        );
                                        setOriginPortInput("");
                                        context.setOriginPort([]);
                                      }}
                                      options={
                                        context.defaultValue.originCountry ?? []
                                      }
                                      getOptionLabel={(option) =>
                                        option.Description
                                      }
                                      sx={{ width: 300 }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label="Select Country"
                                        />
                                      )}
                                    />
                                  </div>
                                  <div className={`width100`}>
                                    <Autocomplete
                                      disabled={ele.IsFreezed || inputDisabled}
                                      disablePortal
                                      disableClearable={false}
                                      size="small"
                                      noOptionsText={
                                        ele.PlanningOriginCountryName?.Code
                                          ?.length
                                          ? originPortInput?.length > 1
                                            ? "No options"
                                            : "Type for search"
                                          : "No options"
                                      }
                                      onInputChange={(e, newValue) => {
                                        setOriginPortInput(newValue ?? "");
                                        if (newValue.length > 1) {
                                          getPorts(
                                            ele.PlanningOriginCountryName.Code,
                                            newValue,
                                            "origin"
                                          );
                                        } else {
                                          context.setOriginPort([]);
                                        }
                                      }}
                                      value={ele.PlanningOriginPortName}
                                      // value={originPort}
                                      onChange={(event, newValue) => {
                                        onChangeHandler(
                                          "PlanningOriginPortName",
                                          newValue ?? { PortName: "" },
                                          index
                                        );
                                      }}
                                      options={context.originPort ?? []}
                                      getOptionLabel={(option) => {
                                        const title = option.PortName
                                          ? option.PortName +
                                            "(" +
                                            option.Code +
                                            ")"
                                          : "";
                                        return title;
                                      }}
                                      sx={{ width: 300 }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label="Select Port"
                                        />
                                      )}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="_orderTimelineDiv">
                                <div className="_orderTimelineDotLine">
                                  <div className="_orderTimelineDot"></div>
                                </div>
                                <div className="_orderTimelineInputs">
                                  <h6>Destination</h6>
                                  <div className={`width100`}>
                                    <Autocomplete
                                      disabled={ele.IsFreezed || inputDisabled}
                                      disablePortal
                                      disableClearable={false}
                                      size="small"
                                      value={ele.PlanningDestinationCountryName}
                                      onChange={(event, newValue) => {
                                        onChangeHandler(
                                          "PlanningDestinationCountryName",
                                          newValue ?? { Description: "" },
                                          index
                                        );
                                        setDestinationPortInput("");
                                        context.setDestinationPort([]);
                                      }}
                                      options={
                                        context.defaultValue.originCountry ?? []
                                      }
                                      getOptionLabel={(option) =>
                                        option.Description
                                      }
                                      sx={{ width: 300 }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label="Select Country"
                                        />
                                      )}
                                    />
                                  </div>
                                  <div className={`width100`}>
                                    <Autocomplete
                                      disabled={ele.IsFreezed || inputDisabled}
                                      disablePortal
                                      disableClearable={false}
                                      size="small"
                                      value={ele.PlanningDestinationPortName}
                                      noOptionsText={
                                        ele.PlanningDestinationCountryName?.Code
                                          ?.length
                                          ? destinationPortInput?.length > 1
                                            ? "No options"
                                            : "Type for search"
                                          : "No options"
                                      }
                                      ListboxProps={{
                                        style: {
                                          maxHeight: "12rem",
                                        },
                                      }}
                                      onChange={(event, newValue) => {
                                        setDestinationPortInput(newValue ?? "");
                                        onChangeHandler(
                                          "PlanningDestinationPortName",
                                          newValue ?? { PortName: "" },
                                          index
                                        );
                                      }}
                                      onInputChange={(e, newValue) => {
                                        if (newValue.length > 1) {
                                          getPorts(
                                            ele.PlanningDestinationCountryName
                                              .Code,
                                            newValue,
                                            "Destination"
                                          );
                                        } else {
                                          context.setDestinationPort([]);
                                        }
                                      }}
                                      options={context.destinationPort ?? []}
                                      getOptionLabel={(option) => {
                                        const title = option.PortName
                                          ? option.PortName +
                                            "(" +
                                            option.Code +
                                            ")"
                                          : "";
                                        return title;
                                      }}
                                      sx={{ width: 300 }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label="Select Port"
                                        />
                                      )}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-7 col-12 _orderContData">
                            {/* <h5>
                          Shipping date availibility &amp; Container number
                        </h5> */}
                            <div className="row _orderContDataInputs">
                              <div className="col-sm-6 col-12">
                                <FieldDate
                                  disableDate={ele.IsFreezed || inputDisabled}
                                  label="Departure Date"
                                  value={ele.PlanningEstimatedDepart}
                                  onChange={(e) => {
                                    onChangeHandler(
                                      "PlanningEstimatedDepart",
                                      e,
                                      index
                                    );
                                  }}
                                />
                              </div>
                              <div className="col-sm-6 col-12">
                                <FieldDate
                                  disableDate={ele.IsFreezed || inputDisabled}
                                  label="Arrival Date"
                                  value={ele.PlanningEstimatedArrival}
                                  onChange={(e) => {
                                    onChangeHandler(
                                      "PlanningEstimatedArrival",
                                      e,
                                      index
                                    );
                                  }}
                                />
                              </div>
                              <div className="col-sm-6 col-12">
                                <FieldDate
                                  disableDate={ele.IsFreezed || inputDisabled}
                                  label="Cut Off Date"
                                  value={ele.PlanningCutOfDate}
                                  onChange={(e) => {
                                    onChangeHandler(
                                      "PlanningCutOfDate",
                                      e,
                                      index
                                    );
                                  }}
                                />
                              </div>
                              <div className="col-sm-6 col-12">
                                <FieldDate
                                  label="Order Ready Date"
                                  disableDate={true}
                                  value={
                                    location.state.editOrderJSON?.OrderHeader
                                      ?.OrderExWorksRequiredBy
                                  }
                                />
                              </div>
                              {location.state.editOrderJSON?.OrderHeader?.OrderTransportMode?.includes(
                                "AIR"
                              ) ? null : (
                                <div className="col-sm-6 col-12">
                                  <FieldText
                                    disabled={ele.IsFreezed || inputDisabled}
                                    label="Vessel"
                                    value={ele.PlanningVessel}
                                    onChange={(e) => {
                                      onChangeHandler(
                                        "PlanningVessel",
                                        e.target.value,
                                        index
                                      );
                                    }}
                                  />
                                </div>
                              )}
                              <div className="col-sm-6 col-12">
                                <FieldText
                                  disabled={ele.IsFreezed || inputDisabled}
                                  label={
                                    location.state.editOrderJSON?.OrderHeader?.OrderTransportMode?.includes(
                                      "AIR"
                                    )
                                      ? "Flight Number"
                                      : "Voyage Number"
                                  }
                                  value={ele.PlanningVoyage}
                                  onChange={(e) => {
                                    onChangeHandler(
                                      "PlanningVoyage",
                                      e.target.value,
                                      index
                                    );
                                  }}
                                />
                              </div>
                              <div className="col-sm-6 col-12">
                                <div className={`width100`}>
                                  <Autocomplete
                                    disabled={ele.IsFreezed || inputDisabled}
                                    disablePortal
                                    disableClearable={false}
                                    size="small"
                                    value={ele.PlanningCarrierCode}
                                    onChange={(event, newValue) => {
                                      onChangeHandler(
                                        "PlanningCarrierCode",
                                        newValue ?? { OrgCode: "" },
                                        index
                                      );
                                    }}
                                    options={carrierOptions ?? []}
                                    getOptionLabel={(option) => option.OrgCode}
                                    sx={{ width: 300 }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label={
                                          location.state.editOrderJSON?.OrderHeader?.OrderTransportMode?.includes(
                                            "AIR"
                                          )
                                            ? "Airline"
                                            : "Carrier"
                                        }
                                      />
                                    )}
                                  />
                                </div>
                              </div>
                              <div className="col-sm-6 col-12">
                                <div className={`width100`}>
                                  <Autocomplete
                                    disabled={ele.IsFreezed || inputDisabled}
                                    disablePortal
                                    disableClearable={false}
                                    size="small"
                                    value={ele.PlanningFinalDestination}
                                    ListboxProps={{
                                      style: {
                                        maxHeight: "12rem",
                                      },
                                    }}
                                    onChange={(event, newValue) => {
                                      onChangeHandler(
                                        "PlanningFinalDestination",
                                        newValue ?? { PortName: "" },
                                        index
                                      );
                                    }}
                                    onInputChange={(e, newValue) => {
                                      if (newValue.length > 1) {
                                        getPorts(
                                          ele.PlanningDestinationCountryName
                                            .Code,
                                          newValue,
                                          "Destination"
                                        );
                                      } else {
                                        context.setDestinationPort([]);
                                      }
                                    }}
                                    options={context.destinationPort ?? []}
                                    getOptionLabel={(option) => {
                                      const title = option.PortName
                                        ? option.PortName +
                                          "(" +
                                          option.Code +
                                          ")"
                                        : "";
                                      return title;
                                    }}
                                    sx={{ width: 300 }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label="Final Destinations Port"
                                      />
                                    )}
                                  />
                                </div>
                              </div>
                              <div className="col-sm-6 col-12">
                                <FieldText
                                  disabled={ele.IsFreezed || inputDisabled}
                                  label={
                                    location.state.editOrderJSON?.OrderHeader?.OrderTransportMode?.includes(
                                      "AIR"
                                    )
                                      ? "Master Airway Bill Number"
                                      : "Master Bill of Lading Number"
                                  }
                                  type="text"
                                  // pattern="[0-9]*"
                                  size="small"
                                  value={ele.PlanningMasterBill}
                                  onChange={(e) => {
                                    onChangeHandler(
                                      "PlanningMasterBill",
                                      e.target.value,
                                      index
                                    );
                                  }}
                                />
                              </div>
                              <div className="col-sm-6 col-12">
                                <div className={`width100`}>
                                  <Autocomplete
                                    disabled={ele.IsFreezed || inputDisabled}
                                    disablePortal
                                    disableClearable={false}
                                    size="small"
                                    value={ele.PlanningForwarderCarrier}
                                    onChange={(event, newValue) => {
                                      onChangeHandler(
                                        "PlanningForwarderCarrier",
                                        newValue ?? { value: "" },
                                        index
                                      );
                                    }}
                                    options={forwarderOptions ?? []}
                                    getOptionLabel={(option) => option.value}
                                    sx={{ width: 300 }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label="Forwarder/Carrier"
                                      />
                                    )}
                                  />
                                </div>
                              </div>
                              {/* {context.orderUserAccess?.ViewRates ? (
                                <div className="col-sm-6 col-12">
                                  {ele.PlanningForwarderCarrier.value ===
                                  "MTS" ? (
                                    <div className="width100">
                                      <TextField
                                        disabled={
                                          ele.IsFreezed || inputDisabled
                                        }
                                        label="Rates"
                                        type="number"
                                        pattern="[0-9]*"
                                        size="small"
                                        value={ele.PlanningRates}
                                        onChange={(e) => {
                                          if (parseInt(e.target.value) < 0) {
                                            onChangeHandler(
                                              "PlanningRates",
                                              Math.abs(
                                                parseInt(e.target.value)
                                              ),
                                              index
                                            );
                                          } else {
                                            onChangeHandler(
                                              "PlanningRates",
                                              e.target.value,
                                              index
                                            );
                                          }
                                        }}
                                      />
                                    </div>
                                  ) : null}
                                </div>
                              ) : null} */}

                              {ele.PlanningForwarderCarrier.value === "MTS" &&
                              context.orderUserAccess?.ViewRates ? (
                                <>
                                  <div className="col-12 _orderConatinerNumberButton">
                                    <strong>Rate Per Container</strong>
                                    <div className="_outlineButton">
                                      <button
                                        disabled={inputDisabled}
                                        onClick={() =>
                                          onContainerRatesAdd(index)
                                        }
                                      >
                                        Add
                                      </button>
                                    </div>
                                  </div>
                                  {ele.OrderPlanningContainerRatesCollection
                                    ? ele?.OrderPlanningContainerRatesCollection.map(
                                        (item, itemIndex) => {
                                          return (
                                            <>
                                              <div className="col-sm-6 col-12">
                                                <div className="width100">
                                                  <Autocomplete
                                                    disabled={inputDisabled}
                                                    disablePortal
                                                    disableClearable={false}
                                                    size="small"
                                                    value={
                                                      item?.ContainerRType ?? ""
                                                    }
                                                    onChange={(
                                                      event,
                                                      newValue
                                                    ) => {
                                                      onContainerRateChange(
                                                        newValue,
                                                        "ContainerRType",
                                                        index,
                                                        itemIndex
                                                      );
                                                    }}
                                                    options={
                                                      context.defaultValue
                                                        .containerType
                                                    }
                                                    getOptionLabel={(option) =>
                                                      option.Code
                                                    }
                                                    renderInput={(params) => (
                                                      <TextField
                                                        {...params}
                                                        label="Container Type"
                                                      />
                                                    )}
                                                  />
                                                </div>
                                              </div>
                                              <div className="col-sm-6 col-12">
                                                <FieldText
                                                  disabled={inputDisabled}
                                                  label="Container Rate"
                                                  value={item.ContainerTypeRate}
                                                  onChange={(e) => {
                                                    onContainerRateChange(
                                                      e.target.value,
                                                      "ContainerTypeRate",
                                                      index,
                                                      itemIndex
                                                    );
                                                  }}
                                                />
                                              </div>

                                              <div className="col-12 _orderPlanContainers">
                                                <div className="_solidButton">
                                                  <button
                                                    disabled={inputDisabled}
                                                    onClick={() =>
                                                      onContainerRatesRemove(
                                                        index,
                                                        itemIndex,
                                                        item
                                                      )
                                                    }
                                                  >
                                                    Remove
                                                  </button>
                                                </div>
                                              </div>
                                            </>
                                          );
                                        }
                                      )
                                    : null}
                                </>
                              ) : null}
                              {location.state.editOrderJSON?.OrderHeader
                                ?.OrderStatus === "SHP" ? (
                                <>
                                  {ele.OrderPlanningContainerCollection.map(
                                    (item, itemIndex) => {
                                      return (
                                        <>
                                          <div className="col-12 _orderConatinerNumberButton">
                                            <strong>
                                              Container #{itemIndex + 1}
                                            </strong>
                                            <div className="_outlineButton">
                                              <button
                                                disabled={inputDisabled}
                                                onClick={() => {
                                                  onContainerRemove(
                                                    index,
                                                    itemIndex,
                                                    ele,
                                                    item
                                                  );
                                                }}
                                              >
                                                Remove
                                              </button>
                                            </div>
                                          </div>
                                          <div className="col-sm-6 col-12">
                                            <FieldText
                                              disabled={inputDisabled}
                                              label="Container Number"
                                              value={item.ContainerNumber}
                                              onChange={(e) => {
                                                onContainerHandler(
                                                  "ContainerNumber",
                                                  e.target.value,
                                                  index,
                                                  itemIndex
                                                );
                                              }}
                                            />
                                          </div>
                                          <div className="col-sm-6 col-12">
                                            <div className="width100">
                                              <Autocomplete
                                                disabled={inputDisabled}
                                                disablePortal
                                                disableClearable={false}
                                                size="small"
                                                value={item.ContainerType}
                                                onChange={(event, newValue) => {
                                                  onContainerHandler(
                                                    "ContainerType",
                                                    newValue,
                                                    index ?? { Code: "" },
                                                    itemIndex
                                                  );
                                                }}
                                                options={
                                                  context.defaultValue
                                                    .containerType
                                                }
                                                getOptionLabel={(option) =>
                                                  option.Code
                                                }
                                                renderInput={(params) => (
                                                  <TextField
                                                    {...params}
                                                    label="Container Type"
                                                  />
                                                )}
                                              />
                                            </div>
                                          </div>
                                          <div className="col-sm-6 col-12">
                                            <TextField
                                              label="Container Weight"
                                              disabled={inputDisabled}
                                              type="number"
                                              pattern="[0-9.]*"
                                              size="small"
                                              value={item.ContainerWeight}
                                              onChange={(e) => {
                                                if (
                                                  parseInt(e.target.value) < 0
                                                ) {
                                                  onChangeHandler(
                                                    "ContainerWeight",
                                                    Math.abs(
                                                      parseInt(e.target.value)
                                                    ),
                                                    itemIndex
                                                  );
                                                } else {
                                                  onChangeHandler(
                                                    "ContainerWeight",
                                                    e.target.value,
                                                    itemIndex
                                                  );
                                                }
                                              }}
                                            />
                                          </div>
                                          <div className="col-sm-6 col-12 _orderPlanContainers">
                                            <div className="width100">
                                              <Autocomplete
                                                disabled={inputDisabled}
                                                disablePortal
                                                disableClearable={false}
                                                size="small"
                                                value={item.ContainerWeightUnit}
                                                onChange={(event, newValue) => {
                                                  onContainerHandler(
                                                    "ContainerWeightUnit",
                                                    newValue,
                                                    index ?? {
                                                      Description: "",
                                                    },
                                                    itemIndex
                                                  );
                                                }}
                                                options={
                                                  context.defaultValue
                                                    .weightType
                                                }
                                                getOptionLabel={(option) =>
                                                  option.Description
                                                }
                                                renderInput={(params) => (
                                                  <TextField
                                                    {...params}
                                                    label="Weight Unit"
                                                  />
                                                )}
                                              />
                                            </div>
                                          </div>
                                        </>
                                      );
                                    }
                                  )}
                                  <div className="col-12 _orderPlanContainers">
                                    <div className="_solidButton">
                                      <button
                                        disabled={inputDisabled}
                                        onClick={() => onAddContainer(index)}
                                      >
                                        Add Containers
                                      </button>
                                    </div>
                                  </div>
                                </>
                              ) : null}
                            </div>
                            {location.state.editOrderJSON?.OrderHeader
                              ?.OrderStatus === "SHP" ? (
                              ""
                            ) : (
                              <>
                                <div className="row _orderContRadio">
                                  <div className="col-12">
                                    <FormControl component="fieldset">
                                      <FormLabel component="legend">
                                        Available Directions
                                      </FormLabel>
                                      <RadioGroup
                                        row
                                        value={directions}
                                        onChange={(e) => {
                                          if (!inputDisabled) {
                                            setDirections(e.target.value);
                                          }
                                        }}
                                      >
                                        <FormControlLabel
                                          value="D"
                                          control={<Radio />}
                                          label="Earlier Departure Date"
                                        />
                                        <FormControlLabel
                                          value="A"
                                          control={<Radio />}
                                          label="Latest Arrival Date"
                                        />
                                      </RadioGroup>
                                    </FormControl>
                                  </div>
                                </div>
                                <div className="row _orderContSlider">
                                  <div className="col-8">
                                    <div>{valueSlider} Weeks</div>
                                    <Slider
                                      valueSlider={valueSlider}
                                      setValueSlider={
                                        inputDisabled
                                          ? () => {}
                                          : setValueSlider
                                      }
                                    />
                                  </div>
                                  <div className="col-4">
                                    <div className="_solidButton">
                                      <button
                                        disabled={inputDisabled}
                                        onClick={() => getScheduleCards(ele)}
                                      >
                                        FIND
                                      </button>
                                    </div>
                                  </div>
                                </div>{" "}
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4 col-12 _orderPlanMap">
                        <OrderMap
                          originCoor={ele.PlanningOriginPortName}
                          destinationCoor={ele.PlanningDestinationPortName}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </TabPanel>
            );
          })}
        </TabContext>
      </div>
    </LayoutCreateOrder>
  );
}

export default OrderPlan;
